module.exports = __webpack_public_path__ + "assets/tomcat.20d344e8.svg";